export enum DifficultyLevel {
  beginner = "Beginner",
  intermediate = "Intermediate",
  advanced = "Advanced",
}
